<div class="flex flex-col items-center justify-center gap-4 mt-4">
  <mat-progress-spinner mode="indeterminate" [diameter]="36"></mat-progress-spinner>
  <p class="font-bold">
    {{ 'HEATING_COOLING_CIRCUIT_REMOTE_DEFROST.DEFROSTING_RUNNING' | translate }}
  </p>
  <span>
    {{ 'HEATING_COOLING_CIRCUIT_REMOTE_DEFROST.ONE_TIME.DEFROSTING_ESTIMATE' | translate }}
  </span>
</div>
